import React, { Component } from 'react'
import { Container } from 'react-bootstrap'

import CustomExamSectionMiddle from '../components/exams/custom_exam_test/CustomExamSectionMiddle';
import ScheduleExamSectionMiddle from '../components/exams/schedule_exam_test/ScheduleExamSectionMiddle';
import SeriesExamSectionMiddle from '../components/exams/test_series_test/SeriesExamSectionMiddle';
import * as Cookies from "es-cookie";
import gql from "graphql-tag";
import { graphql } from "react-apollo";

import * as compose from 'lodash.flowright';
import PreloaderTwo from '../components/preloader/PreloaderTwo'
import CustomSeriesExamSectionMiddle from '../components/exams/customtest_series_test/CustomSeriesExamSectionMiddle';
import ReactGA from 'react-ga';
import { GoogleAnalyticsArray } from './GoogleAnalytics';

const FETCH_STUDENTEXAMQUESTION = gql`
  query(
          $mobile: String!, $exam_session_id: Int!,$type: String
$exam_paper_id: Int) {
    
            getStudentExamQuestions(mobile: $mobile, exam_session_id: $exam_session_id,
                type: $type,
                exam_paper_id: $exam_paper_id){
              id
              subject
              examType
              sub_exam_type
              question
              option1
              option2
              option3
              option4
              qtype
              compquestion
              list1type
              list2type
              mat_question
              mat_que_paragraph
              mat_que_footer
              explanation
              answer
              inputquestion
              bookmarked
              report{
                report_id
                comments
              }
              notes{
                tags
                comments
              }
              subject_name
              mains_2021
              selection_type
              section_name
              no_of_questions
              no_of_qus_answer
              exam_pattern_id
              no_of_marks
              no_of_neg_marks
              order_by
              indexvalue
              starting_no_val
              ending_no_val
     is_advanced
          }
      }
`;

const FETCH_EXAMINSTRUCTIONS = gql`
  query(
          $mobile: String!, $exam_session_id: Int!,$type: String
$exam_paper_id: Int) {
    
    getExamInstructions(mobile: $mobile, exam_session_id: $exam_session_id,
                type: $type,
                exam_paper_id: $exam_paper_id){
                    is_exam
                    exam_id
                    exam_model_id
                    exam_type
                    instructions
                    exam_status
                    status_text
                    is_partexam
                    exam_pattern_id
                    time_duration
                    start_time
                    exam_model_type_id
                    exam_duration_min
          }
      }
`;
const AUTO_SAVE_TIME = gql` 
query($mobile: String!) {
    getAutoTypeExam(mobile: $mobile){
        type_name
        value
    }
}
`;


const AUTO_SUBMIT_TIME = gql` 
query($mobile: String!,$exam_paper_id:Int!) {
    getAutoSubmitTime(mobile: $mobile,exam_paper_id:$exam_paper_id){
        auto_submit_time
        is_proctoring_enabled
        proctoring_attempt_limit {
            proctoring_type_id
            max_allowed
        }
    }
}
`;
const GET_AUTO_SAVE_TIME = gql` 
query($mobile: String!,$exam_paper_id: Int!,$source:String!,$exam_session_id: Int!) {
    getAutoSaveExam(mobile: $mobile,exam_paper_id: $exam_paper_id,source:$source,exam_session_id:$exam_session_id){
        qsno
        questions_data
        mobile
        exam_paper_id
        examtimer
        uid
    }
}
`;
const STUDENT_GLOBALS = gql`
  query(
          $mobile: String!) {
            studentGlobals(mobile: $mobile){
                errorReasons{
                    id
                    reason
                }
                reports{
            id
            report
        }
        tags{
            id
            tag
            type
        }
        exam_time
       
              
          }
      }
`;

const UPDATE_STUDENT_ANALYTICS = gql`
mutation(
  $params:AnalyticsStudents1  
  ) {
      studentAnalytics(
      params: $params
   )
}
`;

class CustomExamTest extends Component {
    constructor(props) {
        super(props);
        this.state = {
            submitError: ""

        }
        let resumeExam = false;
        let local = localStorage.getItem("resumeExam");
        if (props.history.location.state && (props.history.location.state || {}).resumeExam && (props.history.location.state || {}).resumeExam == true) {
            resumeExam = true;
        } else if (!!local && local == "true") {
            resumeExam = true;
        }
        this.state = {
            toggled: "wrapper sidebar-enable",
            resumeExam: resumeExam,
            isOnline: navigator.onLine
        }
    }
    // OFFLINE FUNCTIONALITY DISABLED
    // updateOnlineStatus = () => {
    //     this.setState({ isOnline: navigator.onLine });
    // }
    menuToggler = () => {
        const toggled = Cookies.get("toggle");
        if (toggled === "wrapper") {
            this.setState({ toggled: "wrapper sidebar-enable" });
            Cookies.set("toggle", "wrapper sidebar-enable");
        } else {
            this.setState({ toggled: "wrapper" });
            Cookies.set("toggle", "wrapper");
        }
    };

    handleWindow = e => {
        //alert("hello: " + e.type);
    };
    componentDidMount() {
        this.addStudentAnalytics();
        // OFFLINE FUNCTIONALITY DISABLED
        // window.addEventListener('online', this.updateOnlineStatus);
        // window.addEventListener('offline', this.updateOnlineStatus);


        let title = "";
        if (Cookies.get("examid") == 3 || Cookies.get("examid") == 6 || Cookies.get("examid") == 7 || Cookies.get("examid") == 8) {
            title = GoogleAnalyticsArray[0].Eamcet_Practice_Instructions;
            ReactGA.pageview('/student/subject/exam', title);
        }
        if (localStorage.getItem("etype") == "eamcet_previous") {
            title = GoogleAnalyticsArray[0].Eamcet_Previous_Instructions;
            ReactGA.pageview('/student/subject/exam', title);
        }


        window.onpopstate = e => {
            this.props.history.replace("/student/home", "urlhistory");
        };

        window.addEventListener('contextmenu',
            event => event.preventDefault());

        window.addEventListener("selectstart", e => {
            e.preventDefault();
            e.returnValue = "false";

        });

        window.addEventListener("keypress", e => {
            if (e.key === 'Enter') {
                e.preventDefault();
            }

        });
    }

    addStudentAnalytics = e => {
        let addStudentObj = ""
        if (localStorage.getItem("etype") == "eamcet_previous") {
            addStudentObj = {
                exam_id: parseInt(Cookies.get("examid")),
                mobile: Cookies.get("mobile"),
                analytics_module_page_id: 118,
                source: 2
            }
        } else if (localStorage.getItem("etype") == "jeemainsprevious_exam") {
            addStudentObj = {
                exam_id: parseInt(Cookies.get("examid")),
                mobile: Cookies.get("mobile"),
                analytics_module_page_id: 98,
                source: 2
            }
        }

        else if (localStorage.getItem("etype") == "error") {
            addStudentObj = {
                exam_id: parseInt(Cookies.get("examid")),
                mobile: Cookies.get("mobile"),
                analytics_module_page_id: 66,
                source: 2
            }
        }
        else if (localStorage.getItem("etype") == "custom") {
            addStudentObj = {
                exam_id: parseInt(Cookies.get("examid")),
                mobile: Cookies.get("mobile"),
                analytics_module_page_id: 48,
                source: 2
            }
        }
        else if (localStorage.getItem("etype") == "foundation_exam") {
            addStudentObj = {
                exam_id: parseInt(Cookies.get("examid")),
                mobile: Cookies.get("mobile"),
                analytics_module_page_id: 212,
                source: 2
            }
        }
        else if (localStorage.getItem("examtype_pattern") == "free_foundation_exam") {
            addStudentObj = {
                exam_id: parseInt(Cookies.get("examid")),
                mobile: Cookies.get("mobile"),
                analytics_module_page_id: 229,
                source: 2
            }
        }
        else if (localStorage.getItem("examtype_pattern") == "state_error_exam") {
            addStudentObj = {
                exam_id: parseInt(Cookies.get("examid")),
                mobile: Cookies.get("mobile"),
                analytics_module_page_id: 225,
                source: 2
            }
        }
        else if (localStorage.getItem("examtype_pattern") == "partner_exam") {
            addStudentObj = {
                exam_id: parseInt(Cookies.get("examid")),
                mobile: Cookies.get("mobile"),
                analytics_module_page_id: 234,
                source: 2
            }
        } else if (localStorage.getItem("examtype_pattern") == "college_schedule_exam") {
            addStudentObj = {
                exam_id: parseInt(Cookies.get("examid")),
                mobile: Cookies.get("mobile"),
                analytics_module_page_id: 234,
                source: 2
            }
        }



        this.submitpt(
            addStudentObj
        ).catch(error => {
            this.setState({
                submitError: error.graphQLErrors.map(x => x.message)
            });
        });
    }

    submitpt = async (
        params) => {
        await this.props.submitpt({
            variables: {
                params
            },
        });
    };

    componentWillUnmount() {
        //console.log("componentWillUnmount", window, this.props);
        // window.removeEventListener('online', this.updateOnlineStatus);
        // window.removeEventListener('offline', this.updateOnlineStatus);
        window.removeEventListener("keypress", this.handleWindow);
        window.removeEventListener('contextmenu', this.handleWindow);

        window.removeEventListener("selectstart", this.handleWindow);

    }
    render() {
        if (Cookies.get("studenttoken") == undefined)
            this.props.history.push("/student/login");


        const localData = {
            sessionid: localStorage.getItem('sessionid'),
            type: localStorage.getItem('type'),
            stype: localStorage.getItem('stype'),
            exam_paper_id: localStorage.getItem('exam_paper_id'),
            etype: localStorage.getItem('etype'),
            subexamtype: localStorage.getItem('subexamtype'),
            institute_id: parseInt(Cookies.get("institution_id")) || 0
        }
        const getStudentExamQuestions = this.props.getStudentExamQuestions;
        const loading1 = getStudentExamQuestions.loading;
        const error1 = getStudentExamQuestions.error;
        //if (loading1) return null;
        if (error1 !== undefined && this.state.isOnline) {
            alert("Server Error. " + error1.message);
            return null;
        }
        const studentGlobals = this.props.studentGlobals;
        const loading2 = studentGlobals.loading;
        const error2 = studentGlobals.error;
        if (error2 !== undefined && this.state.isOnline) {
            alert("Server Error. " + error2.message);
            return null;
        }

        const getExamInstructions = this.props.getExamInstructions;
        const loading3 = getExamInstructions.loading;
        const error3 = getExamInstructions.error;
        const getAutoTypeExam = this.props.getAutoTypeExam;
        const loading4 = getAutoTypeExam.loading;
        const error4 = getAutoTypeExam.error;

        const getAutoSaveExam = this.props.getAutoSaveExam;
        const loading5 = getAutoSaveExam.loading;
        const error5 = getAutoSaveExam.error;

        const getAutoSubmitTime = this.props.getAutoSubmitTime;
        const loading6 = getAutoSubmitTime.loading;
        const error6 = getAutoSubmitTime.error;

        if (error3 !== undefined && this.state.isOnline) {
            alert("Server Error. " + error3.message);
            return null;
        }

        return (

            <div className={Cookies.get("toggle")}>
                {/* OFFLINE FUNCTIONALITY DISABLED */}
                {/* {!this.state.isOnline && (
                    <div style={{ backgroundColor: '#dc3545', color: 'white', textAlign: 'center', padding: '10px', fontSize: '16px', fontWeight: 'bold', position: 'fixed', top: 0, left: 0, width: '100%', zIndex: 10002 }}>
                        <i className="fas fa-wifi-slash mr-2"></i> Offline Mode: No Internet Connection.
                    </div>
                )} */}
                {/* Wait for the autosave row too: the exam screen reads it once, on mount, to resume. */}
                {(loading1 == true || loading3 == true || loading2 == true || loading5 == true) && (<PreloaderTwo />)}
                {
                    !loading1 && !loading3 && !loading2 && !loading5 && (
                        <React.Fragment>{
                            localStorage.getItem('exam_paper_id') != 0 ? (
                                // <ScheduleExamSectionMiddle
                                //     getExamInstructions={getExamInstructions.getExamInstructions}
                                //     changeToggle={this.menuToggler
                                //     }
                                //     studentGlobals={studentGlobals.studentGlobals}
                                //     getPracticeQuestions={getStudentExamQuestions.getStudentExamQuestions}
                                //     getData={localData}
                                // />
                                <ScheduleExamSectionMiddle
                                    getExamInstructions={getExamInstructions.getExamInstructions}
                                    changeToggle={this.menuToggler}
                                    studentGlobals={studentGlobals.studentGlobals}
                                    getPracticeQuestions={getStudentExamQuestions.getStudentExamQuestions}
                                    getData={localData}
                                    getAutoTypeExam={getAutoTypeExam.getAutoTypeExam}
                                    resumeExam={this.state.resumeExam}
                                    getAutoSaveExam={getAutoSaveExam.getAutoSaveExam}
                                    getAutoSubmitTime={getAutoSubmitTime.getAutoSubmitTime}
                                />
                            ) : (
                                <CustomSeriesExamSectionMiddle
                                    getExamInstructions={getExamInstructions.getExamInstructions}
                                    changeToggle={this.menuToggler}
                                    studentGlobals={studentGlobals.studentGlobals}
                                    getPracticeQuestions={getStudentExamQuestions.getStudentExamQuestions}
                                    getData={localData}
                                    getAutoTypeExam={getAutoTypeExam.getAutoTypeExam}
                                    resumeExam={this.state.resumeExam}
                                    getAutoSaveExam={getAutoSaveExam.getAutoSaveExam}
                                    getAutoSubmitTime={getAutoSubmitTime.getAutoSubmitTime}
                                />
                                // <CustomExamSectionMiddle
                                //     getExamInstructions={getExamInstructions.getExamInstructions}
                                //     changeToggle={this.menuToggler}
                                //     studentGlobals={studentGlobals.studentGlobals}
                                //     getPracticeQuestions={getStudentExamQuestions.getStudentExamQuestions}
                                //     getData={localData}
                                // />
                            )}</React.Fragment>


                    )
                }

            </div>
        )
    }
}
export default
    compose(graphql(FETCH_STUDENTEXAMQUESTION,
        {
            options: props => ({



                variables: {
                    mobile: Cookies.get("mobile"),
                    // exam_session_id: parseInt((props.history.location.state || {}).sessionid),
                    // type: (props.history.location.state || {}).stype,
                    // exam_paper_id: parseInt((props.history.location.state || {}).exam_paper_id)
                    exam_session_id: parseInt(localStorage.getItem('sessionid')),
                    type: localStorage.getItem('stype'),
                    exam_paper_id: parseInt(localStorage.getItem('exam_paper_id'))
                }
                ,
                fetchPolicy: "cache-and-network"
            }), name: "getStudentExamQuestions"
        }),
        graphql(FETCH_EXAMINSTRUCTIONS,
            {
                options: props => ({
                    variables: {
                        mobile: Cookies.get("mobile"),
                        exam_session_id: parseInt(localStorage.getItem('sessionid')),
                        type: localStorage.getItem('stype'),
                        exam_paper_id: parseInt(localStorage.getItem('exam_paper_id'))
                    }
                    ,
                    fetchPolicy: "cache-and-network"
                }), name: "getExamInstructions"
            }),
        graphql(AUTO_SAVE_TIME,
            {
                options: props => ({
                    variables: {
                        mobile: Cookies.get("mobile"),
                    },
                    fetchPolicy: 'network-only'
                }),
                name: "getAutoTypeExam"
            }),
        graphql(GET_AUTO_SAVE_TIME,
            {
                options: props => ({
                    variables: {
                        mobile: Cookies.get("mobile"),
                        exam_paper_id: parseInt(localStorage.getItem('exam_paper_id')),
                        source: "2",
                        exam_session_id: parseInt(localStorage.getItem('sessionid')),
                    },
                    fetchPolicy: 'network-only'
                }),
                name: "getAutoSaveExam"
            }),
        graphql(STUDENT_GLOBALS,
            {
                options: props => ({
                    variables: {
                        mobile: Cookies.get("mobile"),
                    }
                    ,
                    fetchPolicy: "cache-and-network"
                }), name: "studentGlobals"
            }), graphql(AUTO_SUBMIT_TIME, {
                options: props => ({
                    variables: {
                        mobile: Cookies.get("mobile"),
                        exam_paper_id: parseInt(localStorage.getItem('exam_paper_id')),
                    }
                    ,
                    fetchPolicy: "cache-and-network"
                }),
                name: "getAutoSubmitTime"
            }),
        graphql(UPDATE_STUDENT_ANALYTICS, {
            name: "submitpt"
        }),

    )(CustomExamTest);
